import React from "react";

const TipoExcursion = ({ data, onClick }) => {
  const optionClick = event => {
    event.preventDefault();
    onClick(data);
  };

  const { cssClass, texto } = data;

  return (
    <div className="column is-one-third has-text-centered">
      <div className={`box is-shadowless borde-puntos ${cssClass}`}>
        <a className={`subtitle ${cssClass}`} onClick={optionClick} href="/#">
          {texto}
        </a>
      </div>
    </div>
  );
};

export default TipoExcursion;
